export enum OrderTypeEnum {
  GARAGE = 'GARAGE',
  PRODUCT = 'PRODUCT',
}
